var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSession(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 11H2.048C2.55 5.947 6.813 2 11.998 2C17.521 2 21.998 6.477 21.998 12C21.998 17.523 17.521 22 11.998 22C6.813 22 2.55 18.053 2.048 13H9.998V16L14.998 12L9.998 8L10 11Z",
    fill: "#6C7275"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSession);
export default __webpack_public_path__ + "static/media/session.645f39da39bb8000666a2040feee6bdc.svg";
export { ForwardRef as ReactComponent };